import Vue from 'vue';
import { Dialog } from 'vant';
import VueRouter from 'vue-router';
import * as util from '@/utils/network';
import wx from "weixin-js-sdk";
import config from "../../WebConfig";
Vue.use(VueRouter)
const routes = [{
	path: '/hbPage',
	name: 'hbPage',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/NewPages/hbPage'], resolve)
}, {
		path: '/hbList',
		name: 'hbList',
		meta: {
			requireAuth: true, // 判断是否需要登录
		},
		component: resolve => require(['@/components/NewPages/HbList'], resolve)
	}, {
	path: '/ShopDetile',
	name: 'shopdetile',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/ShopXqDetile'], resolve)
},
{
	path: '/xieyi',
	name: 'xieyi',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/xieyi'], resolve)
}, {
	path: '/disorder',
	name: 'DisOrder',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/DisOrder'], resolve)
}, {
	path: '/disordernew',
	name: 'DisOrderNew',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/DisOrderNew'], resolve)
}, {
	path: '/shopIndex',
	name: 'shopMain',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/shopIndex'], resolve)
}, {
	path: '/distr',
	name: 'distrMain',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/distrIndex'], resolve)
}, {
	path: '/logout',
	name: 'logout',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/logOut'], resolve)
}, {
	path: '/orderdetailw',
	name: 'orderDW',
	/*meta: {
		requireAuth: true, // 判断是否需要登录
	},*/
	component: resolve => require(['@/components/LeoPages/LeoOrderDetailW'], resolve)
}, {
	path: '/myorder/pay',
	name: 'Pay',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/LeoOrderDetailPay'], resolve)
}, {
	path: '/collect',
	name: 'Collect',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/service/collect'], resolve)
}, {
	path: '/about',
	name: 'About',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/service/about'], resolve)
}, {
	path: '/follow',
	name: 'Follow',
	meta: {
		requireAuth: false, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/follow'], resolve)
}, {
	path: '/newfollow',
	name: 'newFollow',
	meta: {
		requireAuth: false, // 判断是否需要登录
	},
	component: resolve => require(['@/components/NewPages/newfollow'], resolve)
}, {
	path: '/shop',
	name: 'Shop',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/shop'], resolve)
}, {
	path: '/supplier',
	name: 'Supplier',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/index'], resolve),
	// children: [{
	// 	path: 'order',
	// 	component: resolve => require(['@/components/LeoPages/supplier/Order'], resolve),
	// }, {
	// 	path: 'accounts',
	// 	component: resolve => require(['@/components/LeoPages/supplier/Accounts'], resolve),
	// }, {
	// 	path: 'dataanalysis',
	// 	component: resolve => require(['@/components/LeoPages/supplier/DataAnalysis'],resolve),
	// 	children: [{
	// 		path: 'DataGk',
	// 		component: resolve => require(['@/components/LeoPages/supplier/dataFile/DataGk'],
	// 			resolve)
	// 	}]
	// }, {
	// 	path: 'product',
	// 	component: resolve => require(['@/components/LeoPages/supplier/Product'], resolve),
	// }]
}, {
	path: '/supplier_user',
	name: 'SupplierUser',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/Accounts'], resolve)
}, {
	path: '/supplier_mar',
	name: 'SupplierMer',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/Merchant'], resolve)
}, {
	path: '/supplier_data',
	name: 'SupplierData',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/DataAnalysis'], resolve)
}, {
	path: '/sd_Ky',
	name: 'SupplierDataKy',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/kyTj'], resolve)
}, {
	path: '/age_Tj',
	name: 'SupplierDataAge',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/ageTj'], resolve)
}, {
	path: '/sd_Gk',
	name: 'SupplierDataGk',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/DataGk'], resolve)
}, {
	path: '/sd_Bb',
	name: 'SupplierDataBb',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/DataBb'], resolve)
}, {
	path: '/sd_Jb',
	name: 'SupplierDataBb',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/DataJb'], resolve)
}, {
	path: '/sd_Yb',
	name: 'SupplierDataYb',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/yb'], resolve)
}, {
	path: '/sd_Rb',
	name: 'SupplierDataRb',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/dataFile/rb'], resolve)
}, {
	path: '/supplier_product',
	name: 'SupplierProduct',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/Product'], resolve),

}, {
	path: '/productEdit',
	name: 'productEdit',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/ProductEdit'], resolve),
}, {
	path: '/pEdit_sku',
	name: 'pEditSku',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/sku'], resolve),
}, {
	path: '/sku_setting',
	name: 'skuSetting',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/skuSetting'], resolve),
}, {
	path: '/supplier_order',
	name: 'SupplierOrder',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/Order'], resolve)
}, {
	path: '/supplier_orderTD',
	name: 'SupplierOrderTD',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/OrderTD'], resolve)
}, {
	path: '/supplier_orderTD1',
	name: 'SupplierOrderTD1',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/OrderTD1'], resolve)
}, {
	path: '/supplier_orderDetail',
	name: 'SupplierOrderDetail',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/OrderDetail'], resolve)
}, {
	path: '/supplier_orderDetailTD',
	name: 'SupplierOrderDetailTD',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/supplier/OrderDetailTD'], resolve)
}, {
	path: '/disAppr',
	name: 'DistributorAppr',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/DistributorAppr'], resolve)
}, {
	path: '/Distributor',
	name: 'Distributor',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/Distributor'], resolve)
}, {
	path: '/wfnew',
	name: 'WirteOffNew',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
		isBack: false, //用于判断上一个页面是哪个
	},
	component: resolve => require(['@/components/LeoPages/WirteOffNew'], resolve)
}, {
	path: '/wirteoffcode',
	name: 'WirteOffCode',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
		isBack: false, //用于判断上一个页面是哪个
	},
	component: resolve => require(['@/components/LeoPages/WirteOffCode'], resolve)
}, {
	path: '/wirteoff',
	name: 'WirteOff',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/WirteOff'], resolve),
	children: [{
		path: 'list',
		component: resolve => require(['@/components/LeoPages/WirteOffList'], resolve),
	}]
}, {
	path: '/shopsetting',
	name: 'ShopSetting',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/ShopSetting'], resolve)
}, {
	path: '/dissetting',
	name: 'disSetting',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/DisSetting'], resolve)
}, {
	path: '/dissy',
	name: 'disSy',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/DisSy'], resolve)
},
{
	path: '/shopmanage',
	name: 'ShopManage',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/ShopManage'], resolve)
},
{
	path: '/incomedetails',
	name: 'IncomeDetails',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/IncomeDetails'], resolve)
},
{
	path: '/leoorder',
	name: 'LeoOrder',
	meta: {
		requireAuth: true, // 判断是否需要登录
		keepAlive: true, //该字段表示该页面需要缓存
		// isBack: false, //用于判断上一个页面是哪个
	},
	component: resolve => require(['@/components/LeoPages/LeoOrder'], resolve),
	children: [{
		path: 'detail',
		component: resolve => require(['@/components/LeoPages/LeoOrderDetail'], resolve),
	}]
},
{
	path: '/leoordernew',
	name: 'LeoOrderNew',
	meta: {
		requireAuth: true, // 判断是否需要登录
		keepAlive: true, //该字段表示该页面需要缓存
		// isBack: false, //用于判断上一个页面是哪个
	},
	component: resolve => require(['@/components/LeoPages/LeoOrderNew'], resolve),
	children: [{
		path: 'detail',
		component: resolve => require(['@/components/LeoPages/LeoOrderDetail'], resolve),
	}]
},
{
	path: '/settingxq',
	name: 'ShopXqSetting',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/ShopXqSetting'], resolve)
},
{
	path: '/SetToken',
	name: 'SetToken',
	component: resolve => require(['@/components/SetToken'], resolve),
}, {
	path: '/xpsjall',
	name: 'XpsjAll',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/XpsjAll'], resolve),
},
{
	path: '/xpsj',
	name: 'XpSj',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
		requireAuth: true
	},
	component: resolve => require(['@/components/LeoPages/XpSj'], resolve),
	children: [{
		path: 'sjcpxq',
		component: resolve => require(['@/components/LeoPages/SjcpXq'], resolve),
	}, {
		path: 'searchpagesj',
		name: 'Searchpagesj',
		component: resolve => require(['@/components/LeoPages/SearchPageSj'], resolve),
	}],
},
{
	path: '/leoreList',
	name: 'LeoReList',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/LeoReList'], resolve),
},
{
	path: '/searchpagesj',
	name: 'SearchPageSj',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/SearchPageSj'], resolve),
},
{
	path: '/sjcpxq',
	name: 'SjcpXq',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/SjcpXq'], resolve),
},
{
	path: '/myshop',
	name: 'MyShop',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/MyShop'], resolve),
	children: [{
		path: 'shopxq',
		component: resolve => require(['@/components/LeoPages/ShopXq'], resolve),
	}, {
		path: 'searchpage',
		component: resolve => require(['@/components/LeoPages/SearchPage'], resolve),
	}, {
		path: 'goodsdetail',
		component: resolve => require(['@/components/LeoPages/GoodsDetail'], resolve),
	}],
},
{
	path: '/ddchecks',
	name: 'DdCheckS',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/DdCheckS'], resolve),
},
{
	path: '/ddcheckssu',
	name: 'DdCheckSG',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/DdCheckSG'], resolve),
},
{
	path: '/ddcheckhotel',
	name: 'DdCheckHotel',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/DdCheckHotel'], resolve),
},
{
	path: '/ddchecknew',
	name: 'DdCheckNew',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/DdCheckNew'], resolve),
},
{
	path: '/goodsdetail',
	name: 'GoodsDetail',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/GoodsDetail'], resolve),
	// children: [{
	// 	path: 'ddchecks',
	// 	component: resolve => require(['@/components/LeoPages/DdCheckS'], resolve),
	// }]
},
{
	path: '/searchPageSjN',
	name: 'SearchPageSjN',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/SearchPageSjN'], resolve),
},
{
	path: '/searchpage',
	name: 'SearchPage',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/SearchPage'], resolve),
},
{
	path: '/shopxq',
	name: 'ShopXq',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/ShopXq'], resolve),
},
{
	path: '/goods',
	name: 'Goods',
	meta: {
		requireAuth: true, // 判断是否需要登录
		// keepAlive: true, //该字段表示该页面需要缓存
	},
	component: resolve => require(['@/components/Goods'], resolve),
},
{
	path: '/',
	name: 'Index',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
		//requireAuth: true
	},
	component: resolve => require(['@/components/Index'], resolve),
	// children: [{
	// 		path: 'goods',
	// 		component: resolve => require(['@/components/Goods'], resolve),
	// 	},
	// 	// {
	// 	// 	path: 'news',
	// 	// 	component: resolve => require(['@/components/News'], resolve),
	// 	// },

	// ]
},
/*{
	path: '/goods',
	name: 'Goods',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
	},
	component: resolve => require(['@/components/Goods'], resolve),
},*/
{
	path: '/news',
	name: 'News',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/News'], resolve),
},
{
	path: '/pageList',
	name: 'PageList',
	meta: {
		// 	keepAlive: true, //该字段表示该页面需要缓存
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/PageList'], resolve),
},
{
	path: '/plnew',
	name: 'PageListNew',
	meta: {
		// 	keepAlive: true, //该字段表示该页面需要缓存
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/PageListNew'], resolve),
},
{
	path: '/relist',
	name: 'Relist',
	meta: {
		keepAlive: true, //该字段表示该页面需要缓存
	},
	component: resolve => require(['@/components/ReList'], resolve),
	children: [{
		path: 'goods',
		component: resolve => require(['@/components/Goods'], resolve),
	}]
},
{
	path: '/SetToken',
	name: 'SetToken',
	component: resolve => require(['@/components/SetToken'], resolve),
},
{
	path: '/myorder/list',
	name: 'OrderMy',
	meta: {
		requireAuth: true, // 判断是否需要登录
		keepAlive: true, //该字段表示该页面需要缓存
	},
	component: resolve => require(['@/components/LeoPages/OrderMy'], resolve),
	children: [{
		path: 'detail',
		component: resolve => require(['@/components/LeoPages/LeoOrderDetail'],
			resolve),
	}]
},
{
	path: '/my',
	name: 'My',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/My'], resolve),
	children: [{
		path: 'shopapply',
		component: resolve => require(['@/components/LeoPages/ShopApply'], resolve),
	}],
},
{
	path: '/cartindex',
	name: 'CartIndex',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/CartIndex'], resolve),
	children: [{
		path: 'goods',
		component: resolve => require(['@/components/Goods'], resolve),
	},
	{
		path: 'cartcheck',
		component: resolve => require(['@/components/CartCheck'], resolve),
		children: [{
			path: 'adresslist',
			component: resolve => require(['@/components/AdressList'], resolve),
		},
		{
			path: 'adressedit',
			component: resolve => require(['@/components/AdressEdit'], resolve),
		},
		]
	}
	]
},
{
	path: '/adresslist',
	name: 'AdressList',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/AdressList'], resolve),
},
{
	path: '/adressedit',
	name: 'AdressEdit',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/AdressEdit'], resolve),
},
{
	path: '/deposit',
	name: 'Deposit',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/NewPages/Recharge'], resolve),
},
{
	path: '/gmxz',
	name: 'Gmxz',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/NewPages/gmxz'], resolve),
},
{
	path: '/qrcode',
	name: 'QrCode',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/distributor/qrcode'], resolve),
},
{
	path: '/wxapp',
	name: 'wxapp',
	meta: {
		requireAuth: true, // 判断是否需要登录
	},
	component: resolve => require(['@/components/LeoPages/wxapppage'], resolve),
},
{
	path: '/shopshare',
	name: 'shopshare',
	meta: {
		requireAuth: true, // 判断是否需要登录
		keepAlive: true, //该字段表示该页面需要缓存
	},
	component: resolve => require(['@/components/LeoPages/shopshare'], resolve),
},

];

const router = new VueRouter({
	//mode: 'hash',
	mode: 'history', // require service support
	base: process.env.NODE_ENV === 'development' ? 'assets/addons/litestore/vue-mobile/' :
		'jonlv/v2', // 配置项目的基础地址
	//base: 'jonlv/v2', // 配置项目的基础地址
	routes
})
/*router.beforeResolve((to,from,next)=>{
	console.log(to)
	console.log(from)
	to.meta.keepAlive=false;
	from.meta.keepAlive=false;
	next();
})*/
/*router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
		console.log('需要登录');
		if (localStorage.token) { // 判断当前的token是否存在 ； 登录存入的token
			next();
		}
		else {

			var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
			let IsWX = false
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
				IsWX = true
			}
			//未登录 process.env.NODE_ENV === 'development' ? 'assets/addons/litestore/vue-mobile/' :
			var url = config.ROOT + '/index/user/login';
			//alert(url)
			if (IsWX) {
				url = 'https://www.jonlv.com/addons/litestore/api.uservue/connect?platform=wechat&url=' + window.location.href;
			}
			//alert(url);
			window.location.href = url;
		}
	}
	else {
		next();
	}
})*/
router.afterEach((to, from) => { //     伸手党福利
	// window.__wxjs_is_wkwebview
	// true 时 为 IOS 设备
	// false时 为 安卓 设备
	var id = ''
	var goodsId = ''
	if (to.path == '/myshop' || to.path == '/shop' ||
		to.path == '/xpsj' || to.path == '/goodsdetail' ||
		to.path == '/searchpage' ||
		to.path == '/ddchecks') {
		let shop = to.query.store_id != undefined ? to.query.store_id : JSON.parse(localStorage.getItem(
			"shop"));
		id = shop
	}
	if (to.path == '/goodsdetail' || to.path == '/goods') {
		console.log(to.query.id)
		goodsId = to.query.id
	}
	if (window.__wxjs_is_wkwebview) { // IOS
		// console.log('IOS', window.location.href)
		var href = window.location.href
		if (window.entryUrl == '' || window.entryUrl == undefined) {
			window.entryUrl = window.location.href.split('#')[0]
		}
		href = window.entryUrl
		//alert(href);
		getWxAuth(href, id, goodsId, to.path);
	} else { // 安卓
		// console.log('安卓', window.location.href)
		setTimeout(function () {
			getWxAuth(window.location.href, id, goodsId, to.path);
		}, 500);
	}
});

function getWxAuth(href, id, goodsId, path) {
	var url = "/addons/litestore/api.index/getJsSdkConfig"
	//console.log('href',path)
	let param = {
		url: href
	}
	if (id != '') {
		param.store_id = id
	}
	if (goodsId != '') {
		param.goodsId = goodsId
	}
	//这里直接调用网络接口
	util.post(url, param, function (result) {
		//console.log(!result.data.subscribe)
		var arr = result.data.arr;

		if (!result.data.subscribe && arr.indexOf(path) < 0) {
			Dialog.alert({
				title: '温馨提示',
				message: result.data.message,
			}).then(() => {
				util.redirect(result.data.subscribe_url)
				// on close
			});
			return;
		}

		var shareMsage = result.data.shareMessage;
		//初始配置
		var config = result.data.config;

		wx.config({
			debug: config.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
			appId: config.appId, // 必填，公众号的唯一标识
			timestamp: config.timestamp, // 必填，生成签名的时间戳
			nonceStr: config.nonceStr, // 必填，生成签名的随机串
			signature: config.signature, // 必填，签名
			jsApiList: config.jsApiList, // 必填，需要使用的JS接口列表
			openTagList: config.openTagList, // 必填，需要使用的开放接口列表
		});

		wx.ready((readyres) => {
			wx.checkJsApi({
				jsApiList: config.jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
				success: function (res) {
					console.log('api', res)
					//alert(res)
					// 以键值对的形式返回，可用的api值true，不可用为false
					// 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
				}
			});
			//分享给好友
			wx.updateAppMessageShareData({
				title: shareMsage.title, // 分享标题
				desc: shareMsage.desc, //分享的描述
				link: shareMsage.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
				type: shareMsage.type, // 分享类型,music、video或link，不填默认为link
				imgUrl: shareMsage.imgUrl, // 分享图标
				success: function () {
					//that.$message.success('分享成功')
				},
			});

			// alert("分享朋友圈");
			//分享到朋友圈
			wx.updateTimelineShareData({
				title: shareMsage.title, // 分享标题
				desc: shareMsage.desc, //分享的描述
				link: shareMsage.link, // 分享链接，该链接域名必须与当前企业的可信域名一致
				type: shareMsage.type, // 分享类型,music、video或link，不填默认为link
				imgUrl: shareMsage.imgUrl, // 分享图标
				success: function () {
					//that.$message.success('分享成功')
				},
			});
		});
		wx.error((err) => {
			//alert("配置错误");
			console.log('微信js-sdk配置失败', JSON.parse(err))
			alert('微信js-sdk配置失败:::' + JSON.parse(err))
		})
	},
		function (err) {
			//alert("接口错误")
			console.log('接口错误', err)
		});
}
export default router;
